import axios from 'axios';

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
});

export const listUsers = (page = 1, limit = 10, search = '') => {
  const projectPid = localStorage.getItem('projectPid') || localStorage.getItem('companyPid');
  return axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/users/list`, {
    projectPid, page, limit, search,
  }, { headers: authHeader() });
};

export const createUser = ({ projectPid, firstName, lastName, email, role }) =>
  axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/users/create`, {
    projectPid, firstName, lastName, email, role,
  }, { headers: authHeader() });

export const listProjectUsers = ({ projectPid, search = "", page = 1, limit = 5 }) =>
  axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/users/list`,
    { projectPid, search, page, limit },
    { headers: authHeader() }
  );

export const getUser = (userPid) =>
  axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/users/get`, { userPid }, {
    headers: authHeader(),
  });

export const updateUser = (userPid, { firstName, lastName }) =>
  axios.put(`${process.env.REACT_APP_BASE_URL}/api/v1/users/update`, {
    userPid,
    firstName,
    lastName,
  }, {
    headers: authHeader(),
  });
